const routes = [
  {
    name: 'utrakk-dashboard',
    path: '/portfolio-risk-intelligence',
    meta: {
      requiresAuth: true,
      layout: 'home',
      allowedRoles: ['utrakk-dashboard'],
      embedFullViewport: true,
      breadcrumb: {
        label: 'core.menu.modules.utrakk-dashboard',
        route: 'utrakk-dashboard',
      },
    },
    component: () =>
      import(
        '@/modules/utrakk-dashboard/containers/utrakk-dashboard.container.vue'
      ),
  },
]

export default routes
